exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@charset \"UTF-8\";\n/*\n * Переменные\n */\n.control[data-v-2da323dc] {\n  width: 100%;\n}\n.button[data-v-2da323dc] {\n  padding-top: 12px;\n  padding-bottom: 12px;\n  width: 100%;\n  height: auto;\n  color: #2b67df;\n}\n.button[data-v-2da323dc]:hover {\n  background-color: #FAFAFA;\n  color: #2b67df;\n}", ""]);

// exports
